import React from 'react';
import ReactCountryFlag from 'react-country-flag';

export default function LanguageSelector({ language, onChange, labels }) {
  const flagStyle = {
    width: '1.35em',
    height: '1em',
    borderRadius: '2px',
    objectFit: 'cover',
    display: 'block',
    boxShadow: '0 0 0 1px rgba(15,23,42,0.08)',
  };

  return (
    <div
      className="flex items-center gap-0.5 rounded-full border border-slate-200 bg-slate-100/80 p-0.5"
      role="group"
      aria-label="Language"
    >
      <button
        type="button"
        onClick={() => onChange('fi')}
        className={`flex items-center gap-1.5 rounded-full px-2.5 py-1.5 text-xs font-semibold uppercase tracking-wide transition sm:px-3 sm:gap-2 ${
          language === 'fi'
            ? 'bg-[var(--df-accent)] text-white shadow-sm'
            : 'text-slate-600 hover:bg-white hover:text-slate-900'
        }`}
        aria-pressed={language === 'fi'}
      >
        <ReactCountryFlag countryCode="FI" svg title="Suomi" style={flagStyle} />
        <span className="hidden sm:inline">{labels.langFi}</span>
      </button>
      <button
        type="button"
        onClick={() => onChange('en')}
        className={`flex items-center gap-1.5 rounded-full px-2.5 py-1.5 text-xs font-semibold uppercase tracking-wide transition sm:px-3 sm:gap-2 ${
          language === 'en'
            ? 'bg-[var(--df-accent)] text-white shadow-sm'
            : 'text-slate-600 hover:bg-white hover:text-slate-900'
        }`}
        aria-pressed={language === 'en'}
      >
        <ReactCountryFlag countryCode="GB" svg title="English" style={flagStyle} />
        <span className="hidden sm:inline">{labels.langEn}</span>
      </button>
    </div>
  );
}
